
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SolutionsHero from './components/SolutionsHero';
import ChemicalsList from './components/ChemicalsList';
import NicheTechnologies from './components/NicheTechnologies';
import PublishedArticles from './components/PublishedArticles';
import WellIntervention from './components/WellIntervention';

const Solutions = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <SolutionsHero />
      <ChemicalsList />
      <NicheTechnologies />
      <PublishedArticles />
      <WellIntervention />
      <Footer />
    </div>
  );
};

export default Solutions;
